import React, {FunctionComponent} from 'react';

interface PillPackComMigrationBannerProps {
  pillPackComStatementsInProgress: string;
  pillPackComCheckBackLater: string;
}

/**
 * Banner component to show when PillPackCom migration is in progress
 */
export const PillPackComMigrationBanner: FunctionComponent<PillPackComMigrationBannerProps>
    = ({pillPackComStatementsInProgress, pillPackComCheckBackLater}) => {
  const status = 'information-solid';
  const imgClass = 'status-info-icon';

  return (
      <pui-banner
          direction="vertical"
          flex-direction="column"
          status={status}
          spacingTop="small"
          spacingBottom="small"
      >
        <pui-section flowdirection="horizontal">
          <pui-section-column>
            <pui-icon imgClass={imgClass} spacingRight="mini"/>
          </pui-section-column>
          <pui-section flowdirection="vertical">
            <pui-heading input={pillPackComStatementsInProgress} textSize="small" spacingBottom="mini"/>
            <pui-text input={pillPackComCheckBackLater} inline/>
          </pui-section>
        </pui-section>
      </pui-banner>
  );
};

export default PillPackComMigrationBanner;
